import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'

/**
 * Creates and configures an Axios instance.
 *
 * @param {AxiosRequestConfig} [requestConfig] - Optional Axios request configuration.
 *
 * @returns {axios.AxiosInstance} - The created Axios instance.
 *
 * @example
 * const apiClient = createAxiosInstance({ baseURL: 'https://api.example.com' });
 */
export const createAxiosInstance = (requestConfig?: AxiosRequestConfig | never): AxiosInstance => {
  const instance = axios.create({
    ...requestConfig,
    timeout: 10_000, // 10 seconds
  })

  instance.interceptors.response.use(
    response => response,

    (error: AxiosError) => {
      console.error(JSON.stringify(error, null, 2))

      return Promise.reject(error)
    },
  )

  return instance
}

const apiClient = createAxiosInstance()

export default apiClient
